// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1c006689","455":"25b72960","977":"c62bdc6d"}[chunkId] + ".chunk.js";
};